/* eslint-disable import/named */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable array-callback-return */
// convert any string to camelcase
export const camelize = (str) => str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
  if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
  return index === 0 ? match.toLowerCase() : match.toUpperCase();
});

export const convertObjectKeyValueNames = (obj, wrapper, inputKeyName,
  inputValueName, outputKeyName, outputValueName) => {
  // check if input obj is an array
  obj = wrapper !== null ? obj[wrapper] : obj;

  if (Array.isArray(obj)) {
    const result = obj.map((item) => {
      const tempItem = {};
      tempItem[outputKeyName] = item[inputKeyName];
      tempItem[outputValueName] = item[inputValueName];
      return tempItem;
    });

    return result;
  }
  const result = {};
  result[outputKeyName] = obj[inputKeyName];
  result[outputValueName] = obj[inputValueName];

  return result;
};

export const convertObjectKeyValueNamesUser = (obj, wrapper, inputKeyName,
  inputValueName, inputValueName2, outputKeyName, outputValueName) => {
  // check if input obj is an array
  obj = wrapper !== null ? obj[wrapper] : obj;

  if (Array.isArray(obj)) {
    const result = obj.map((item) => {
      const tempItem = {};
      tempItem[outputKeyName] = item[inputKeyName];
      tempItem[outputValueName] = `${item[inputValueName]} ${item[inputValueName2]}`;
      return tempItem;
    });

    return result;
  }
  const result = {};
  result[outputKeyName] = obj[inputKeyName];
  result[outputValueName] = `${obj[inputValueName]} ${obj[inputValueName2]}`;

  return result;
};

export const convertObjectKeyValueNamesSuperAdminUsers = (obj, wrapper, inputKeyName,
  inputValueName, inputValueName2, inputValueName3, outputKeyName, outputValueName) => {
  // check if input obj is an array
  obj = wrapper !== null ? obj[wrapper] : obj;

  if (Array.isArray(obj)) {
    const result = obj.map((item) => {
      const tempItem = {};
      tempItem[outputKeyName] = item[inputKeyName];
      tempItem[outputValueName] = `${item[inputValueName] || '-'} / ${item[inputValueName2] || '-'} / ${item[inputValueName3] || '-'}`;
      return tempItem;
    });

    return result;
  }
  const result = {};
  result[outputKeyName] = obj[inputKeyName];
  result[outputValueName] = `${obj[inputValueName]} ${obj[inputValueName2]}`;

  return result;
};

export const convertObjectKeyValueNamesAll = (obj, wrapper, inputArr, outputArr) => {
  // check if input obj is an array
  obj = wrapper !== null ? obj[wrapper] : obj;

  const result = obj.map((item) => {
    const keys = [];
    const values = [];
    const tempItem = {};

    outputArr.map((output) => keys.push(output));
    inputArr.map((input, index) => {
      values.push(item[input]);
      // input set output
      tempItem[outputArr[index]] = values[index];
    });

    return tempItem;
  });

  return result;
};

export const handleLocalStorage = {
  setItem: (wrapper, key, value) => {
    const item = handleLocalStorage.getItem(wrapper);

    if (!item || !key) {
      localStorage.setItem(wrapper, JSON.stringify({}));
    } else {
      const currentItem = handleLocalStorage.getItem(wrapper);

      currentItem[key] = value || null;
      localStorage.setItem(wrapper, JSON.stringify(currentItem));
    }
  },
  getItem: (wrapper) => {
    const item = localStorage.getItem(wrapper);
    if (item) {
      return JSON.parse(localStorage.getItem(wrapper));
    }
    return null;
  },
};

const createCookieKey = (name) => {
  const env = process.env.VUE_APP_ENV;
  if (env !== 'production') {
    return `Kariyer_${env}_${name}`;
  }

  return `Kariyer_${name}`;
};

export const handleCookies = {
  getCookieWithNativeJs: (name) => {
    /* let regexp = new RegExp("(?:^" + name + "|;\s*" + name + ")=(.*?)(?:;|$)", "g");
     let result = regexp.exec(document.cookie);
     return (result === null) ? null : result[1]; */
    const re = new RegExp(`[; ]${name}=([^\\s;]*)`);
    const sMatch = (` ${document.cookie}`).match(re);
    if (name && sMatch) {
      return decodeURI(sMatch[1]);
    }
    return '';
  },
  setCookieWithNativeJs: (name, value, expires, path, domain) => {
    let cookie = `${name}=${encodeURI(value)};`;

    if (expires) {
      // If it's a date
      if (expires instanceof Date) {
        // If it isn't a valid date
        if (Date.isNaN(expires.getTime())) expires = new Date();
      } else {
        expires = new Date(new Date().getTime() + +expires * 1000 * 60 * 60 * 24);
      }
      cookie += `expires=${expires.toGMTString()};`;
    }

    if (typeof path !== 'undefined') {
      // eslint-disable-next-line no-undef
      cookie += `path=${path};`;
    }

    if (typeof domain !== 'undefined') {
      // eslint-disable-next-line no-undef
      cookie += `domain=${domain};`;
    }

    document.cookie = cookie;
  },
  deleteCookieWithNativeJs: (name) => {
    // If the cookie exists
    if (handleCookies.getCookieWithNativeJs(name)) {
      handleCookies.setCookieWithNativeJs(name, '', -1);
    }
  },
  setCookie: (obj) => {
    if (window.dejavuApp && window.dejavuApp.$cookie) {
      _.each(obj, (value, name) => {
        const tempName = createCookieKey(name);
        let tempObj = {
          expires: 1,
        };

        if (window.location.hostname.includes('.kariyer.net')) {
          tempObj = {
            ...tempObj,
            domain: '.kariyer.net',
          };
        }
        window.dejavuApp.$cookie.set(tempName, value, { ...tempObj });
      });
    } else {
      _.each(obj, (value, name) => {
        const tempName = createCookieKey(name);
        handleCookies.setCookieWithNativeJs(tempName, value, 1);
      });
    }
  },
  getCookie: (name) => {
    let value = '';
    const tempName = createCookieKey(name);

    if (window.dejavuApp && window.dejavuApp.$cookie) {
      value = window.dejavuApp.$cookie.get(tempName);
    } else {
      value = handleCookies.getCookieWithNativeJs(tempName);
    }
    return value;
  },
  deleteCookie: (name) => {
    const tempName = createCookieKey(name);
    if (window.dejavuApp && window.dejavuApp.$cookie) {
      window.dejavuApp.$cookie.delete(tempName);
      window.dejavuApp.$cookie.delete(tempName, { domain: '.kariyer.net' });
    } else {
      handleCookies.deleteCookieWithNativeJs(tempName);
    }
  },
};

export const generateGuid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const getClientDeviceToken = () => {
  let clientDeviceToken;
  if (!handleCookies.getCookie('clientDeviceToken')) {
    clientDeviceToken = generateGuid();
    handleCookies.setCookie({ clientDeviceToken });
  } else {
    clientDeviceToken = handleCookies.getCookie('clientDeviceToken');
  }
  return clientDeviceToken;
};

export const scrollTo = (elem, offsetTop) => {
  $('html, body')
    .animate({
      scrollTop: ($(elem).offset().top - ($('.page-view').offset().top + 32) - offsetTop),
    }, 'slow');
};

export const removeHTMLTags = (html) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  let result = tmp.textContent || tmp.innerText || '';
  result = result.replace(/\r?\n|\r/g, '');

  return result;
};

export const handleLoader = {
  showLoader() {
    $('#app').addClass('loading');
  },
  hideLoader() {
    $('#app').removeClass('loading');
  },
};

export const showNotification = (title, message, type, duration = 5000) => {
  let iconClass = 'fa-check-circle';
  switch (type) {
    case 'success':
      iconClass = 'fa-check-circle';
      break;
    case 'warning':
    case 'error':
      iconClass = 'fa-warning-circle';
      break;
    case 'info':
      iconClass = 'fa-info';
      break;
    default:
      break;
  }

  window.dejavuApp.$notify({
    duration,
    group: 'custom-notification',
    type,
    title,
    text: message,
    iconClass,
    position: {
      elementPosition: 'bottom left',
      globalPosition: 'top left',
    },
  });
};

export const objectToQueryString = (model) => {
  let generatedQuery = '';
  for (const key in model) {
    generatedQuery += `&${key}=${model[key]}`;
  }
  return generatedQuery;
};
